{
    "HyDhCA9xY8X3dWRm0VP8-": {
        "position": {
            "x": 14,
            "y": 14,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "HyDhCA9xY8X3dWRm0VP8-"
    },
    "M_T6RXBREtofAVKnqYO4y": {
        "position": {
            "x": 14,
            "y": 15,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "M_T6RXBREtofAVKnqYO4y"
    },
    "gPeVeuC4tug2GytNenwOx": {
        "position": {
            "x": 15,
            "y": 15,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "gPeVeuC4tug2GytNenwOx"
    },
    "f-f3TTSNd_E2FC0FTlfra": {
        "position": {
            "x": 15,
            "y": 14,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "f-f3TTSNd_E2FC0FTlfra"
    },
    "djKl-WRiv6WjafOaf_Gcd": {
        "position": {
            "x": 13,
            "y": 17,
            "z": 1
        },
        "templateKey": "jobs/sword",
        "jobKey": "sword",
        "affiliation": "bad",
        "key": "djKl-WRiv6WjafOaf_Gcd"
    },
    "cIhP0fVZ4I9kpTjThG75p": {
        "position": {
            "x": 17,
            "y": 16,
            "z": 1
        },
        "templateKey": "jobs/sword",
        "jobKey": "sword",
        "affiliation": "bad",
        "key": "cIhP0fVZ4I9kpTjThG75p"
    },
    "ruffian": {
        "position": {
            "x": 15,
            "y": 12,
            "z": 1
        },
        "templateKey": "jobs/sword",
        "jobKey": "hammer",
        "affiliation": "bad",
        "key": "ruffian",
        "maxhealth": "60"
    }
}